export default function minutesToHoursString (value) {
  if (!value || Number.isNaN(value) || !Number.isFinite(value)) return ''

  const hours = Math.floor(value / 60)
  const minutes = value % 60
  return `${hours}h ${minutes}m`
}
